import React from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import "bootstrap/dist/css/bootstrap.min.css";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore, persistReducer } from "redux-persist";
import "./index.css";
import App from "./components/App";
import reportWebVitals from "./reportWebVitals";
import reducers from "./reducers/index";
import "antd/dist/antd.css";
import { AppProvider } from "./context/AppContext";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducers,

  composeEnhancers(applyMiddleware(thunk))
);
const persistor = persistStore(store);
ReactDOM.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
    {/* <ToastContainer /> */}
    <PersistGate loading={null} persistor={persistor}>
      <AppProvider>
        <App />
      </AppProvider>
      {/* </React.StrictMode> */}
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

const CURRENT_RELEASE_VERSION = "2026.06.05.3"; // <-- Update this version string whenever you deploy a new release

const storedVersion = localStorage.getItem("app_release_version");
if (storedVersion !== CURRENT_RELEASE_VERSION) {
  console.warn(
    "New release detected! Clearing client-side storage, cache, and cookies..."
  );

  // localStorage.clear();
  sessionStorage.clear();

  document.cookie.split(";").forEach((cookie) => {
    const name = cookie.split("=")[0].trim();
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/ccdc/`;
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=`;
  });

  localStorage.setItem("app_release_version", CURRENT_RELEASE_VERSION);

  window.location.reload(true);
}
// ========================================================
